export enum UserListColumns {
  'ID' = 'ID',
  'SIGN_UP_DATE' = 'SignUp Date',
  'CONSENT_DATE' = 'Consent Date',
  'NAME' = 'Name',
  'EMAIL' = 'Email',
  'STATUS' = 'Status'
}
export const USERS_FILTERS_KEYS = {
  SEARCH: 'search',
  SIGN_UP_DATE: 'registrationDateRange',
  STATUSES: 'selectedStatuses',
  SEARCH_FILTERS: 'searchFilters'
}
export const USER_STATUSES = {
  NEW: 'NEW',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  TESTER: 'TESTER'
}
export const USER_DETAILS_TABS = [
  'Segments',
  'Transactions',
  'Campaigns',
  'Offers',
  'Updates',
  'Connected Apps'
]
export const USER_DETAILS_LEFT_SECOND_CARD_ITEMS = {
  UserID: 'UserID',
  VelociaIDAtTenant: 'VelociaID',
  UserIDAtTenant: 'UserID at Tenant'
}
export const USER_DETAILS_LEFT_THIRD_CARD_ITEMS = {
  EMAIL: 'Email',
  PHONE_NUMBER: 'Phone Number',
  CONTACT_EMAIL: 'Contact Email',
  CONTACT_PHONE_NUMBER: 'Contact Phone Number'
}
export const VERIFIED = 'Verified'
export const POINTS_BALANCE = 'Points Balance'
export const DETAILS_SECOND_CARD_LAST_INDEX = 2
export const DETAILS_CARD_COMMON_CLASSNAMES = 'my-3 border-[#E5E7EB] shadow-md'
export const USER_DETAILS_REFERRAL_INFO_ITEMS = {
  referralCouponCode: 'Code',
  codesEntered: 'Entered on Rewards',
  completedActions: 'Completed Actions',
  referredUserID: 'Referred By'
}
export const CODES_ENTERED = 'codesEntered'
export const COMPLETED_ACTIONS = 'completedActions'
export const USER_DETAILS_TABS_INDEX = {
  SEGMENTS: 0,
  TRANSACTIONS: 1,
  CAMPAIGNS: 2,
  OFFERS: 3,
  UPDATES: 4,
  CONNECTED_APPS: 5
}
export const USER_CAMPAIGNS_TABLE_COLUMNS = [
  'ID',
  'Category',
  'Name',
  'Title',
  'Featured?'
]
export const USER_OFFERS_TABLE_COLUMNS = [
  'ID',
  'Category',
  'Title',
  'Redemptions',
  'Favorite?'
]
export const USER_UPDATES_TABLE_COLUMNS = ['ID', 'Name', 'Title']
export const USER_PROVIDERS_TABLE_COLUMNS = [
  'ID',
  'Provider',
  'Status',
  'Last Sync Date'
]
export const CONNECTED_STATUS = 'Connected'
export const DISCONNECTED_STATUS = 'Disconnected'
export const PENDING_STATUS = 'Pending'
export const USER_PROVIDER_CONNECT_STATUS_MAP = {
  [CONNECTED_STATUS]: {
    borderColor: 'border-green-500',
    bgColor: 'bg-lighter-green',
    color: 'green'
  },
  [DISCONNECTED_STATUS]: {
    borderColor: 'border-red-500',
    bgColor: 'bg-lighter-red',
    color: 'red'
  },
  [PENDING_STATUS]: {
    borderColor: 'border-blue-500',
    bgColor: 'bg-lighter-blue',
    color: 'blue'
  }
}
export const USER_SEGMENTS_TABLE_COLUMNS = [
  'Segment ID',
  'Added Date',
  'Type',
  'Name',
  'Users in Segment',
  ''
]
export const OPTED_OUT_LABEL = '(Opted Out)'
export const USER_OPTIONS_UPDATE_MESSAGE_LIMIT = 500
export const STATUS_UPDATE_ACTION_TYPE = {
  SUSPEND: 'suspend',
  OPT_OUT: 'optOut',
  TEST_MODE: 'testMode',
  DELETE: 'delete'
}
export const USER_STATUS_UPDATE_CONTENT = {
  ACTIVATE: {
    TITLE: 'Activate User',
    CONTENT:
      'Are you sure you want to Activate this user account? User will be allowed to access Rewards if the action is confirmed.'
  },
  SUSPEND: {
    TITLE: 'Suspend User',
    CONTENT:
      'Are you sure you want to Suspend this user account? The user won’t be allowed to access Rewards if the action is confirmed.'
  },
  OPT_IN: {
    TITLE: 'Opt back in User',
    CONTENT: 'Are you sure you want to Opt Back In this user account?'
  },
  OPT_OUT: {
    TITLE: 'Opt-Out User',
    CONTENT: 'Are you sure you want to Opt Out this user account?'
  },
  DELETE: {
    TITLE: 'Delete User Account',
    CONTENT:
      'Are you sure you want to DELETE this user account? The user will need to create a new account to regain access to Reward.'
  },
  MARK_TEST: {
    TITLE: 'Mark as a Tester User',
    CONTENT:
      'Are you sure you want to mark this user as a TESTER? This action cannot be reversed. Any action related to their points balance won’t be considered for invoicing while this user remains in this mode.'
  }
}
export const USER_TRANSACTIONS_TABLE_COLUMNS = [
  'Date',
  'Transaction ID',
  'Description',
  'Amount'
]
export const USER_TRANSACTION_KEYS = {
  FROM_CONNECT_CAMPAIGN: 'FromConnectCampaign',
  FROM_FRIEND_REFERRAL_CAMPAIGN: 'FromFriendReferralCampaign',
  FROM_SURVEY_CAMPAIGN: 'FromSurveyCampaign',
  FROM_ACTION_CAMPAIGN: 'FromActionCampaign',
  FROM_REFERRAL_CAMPAIGN: 'FromReferralCampaign',
  FROM_LOCATION_CAMPAIGN: 'FromLocationCampaign',
  FROM_STREAK_CAMPAIGN: 'FromStreakCampaign',
  FROM_MULTITRIP_CAMPAIGN: 'FromMultiTripCampaign',
  FROM_TIER_CAMPAIGN: 'FromTierCampaign',
  FROM_VELOCIA_SIGNUP: 'FromVelociaSignup',
  FROM_REACTIVATION_BONUS: 'FromReactivationBonus',
  FROM_POINTS_DISTRIBUTION: 'FromPointsDistributions',
  FROM_OFFER_REDEMPTION: 'FromOfferRedemption',
  FROM_TRANSACTIONAL_CAMPAIGN: 'FromTransactionalCampaign',
  FROM_CONDITION_CAMPAIGN: 'FromConditionCampaign',
  FROM_GT_REPORT_CAMPAIGN: 'FromGTReportCampaign',
  SCHEDULED_CAMPAIGN_EARNING_ID: 'ScheduledCampaignEarningID',
  FRIEND_REFERRAL_SIGNUP_TRANSACTION: 'FriendReferralSignUpTransaction',
  PROMOTION_CAMPAIGN_TITLE: 'PromotionCampaignTitle',
  DEDUCTION_TRANSACTION_ID: 'DeductionTransactionID',
  FROM_REFUNDS: 'FromRefunds',
  FROM_EXTERNAL_SURVEY_CAMPAIGN: 'FromExternalSurveyCampaign'
}
export const USER_TRANSACTION_LABELS = {
  APP_CONNECT: 'App Connect:',
  FRIEND_REFERRAL: 'Friend Referral:',
  SURVEY_CAMPAIGN: 'Survey Campaign:',
  ACTION_CAMPAIGN: 'Action Campaign:',
  REFERRAL_CAMPAIGN: 'Referral Campaign:',
  LOCATION_CAMPAIGN: 'Location Campaign:',
  STREAK_CAMPAIGN: 'Streak Campaign:',
  MULTITRIP_CAMPAIGN: 'MultiTrip Campaign:',
  TIER_CAMPAIGN: 'Tier Campaign:',
  VELOCIA_SIGNUP: 'Velocia Signup',
  REACTIVATION_BONUS: 'Reactivation Bonus',
  POINTS_DISTRIBUTION: 'Points Distribution:',
  OFFER_REDEMPTION: 'Redemption:',
  TRANSACTIONAL_CAMPAIGN: 'Transactional Campaign:',
  CONDITION_CAMPAIGN: 'Condition Campaign:',
  GT_REPORT_CAMPAIGN: 'GT Report Campaign:',
  SCHEDULED_CAMPAIGN: 'Scheduled Campaign:',
  VELOCIA_REFERRAL_SIGNUP: 'Velocia Referral Signup:',
  PROMOTION_CAMPAIGN_CLAIMS: 'Promotion Campaign:',
  EXPIRY_DEDUCTION: 'Expiry Deduction:',
  INACTIVITY_DEDUCTION: 'Monthly inactivity deduction',
  SUSPENSION_DEDUCTION: 'Suspension deduction',
  REFUND: 'Refund'
}
export const USER_TRANSACTION_URL_PATHS = {
  USERS: 'users',
  CAMPAIGNS: 'campaigns',
  POINTS_DISTRIBUTION: 'points-distribution',
  OFFERS: 'offers'
}
export const DEDUCTION_TYPES = {
  EXPIRY_DEDUCTION: 'ExpiryDeduction',
  INACTIVITY_DEDUCTION: 'InactivityDeduction'
}
export const USER_TRANSACTION_TYPE_FILTER_KEY = 'transactionType'
export const USER_TRANSACTION_TYPES = [
  'Campaign Earnings',
  'Redemptions',
  'Inactivity Deductions',
  'Refund',
  'Suspension Deductions',
  'Expiry Deductions'
]
export const NEGATIVE_THRESHOLD = 0
export const RETRIEVE_USERS_ACTION = 'RETRIEVE_USERS'
export const RETRIEVE_USERS_ERROR_MSG =
  'Something went wrong while fetching users. Please try again.'

export const DEFAULT_PROGRESS = 0
// Below two consts can be tweaked to align with Prod performance
export const PROGRESS_BAR_CAP = 90
export const PROGRESS_INTERVAL_DELAY = 3000
export const MAX_PROGRESS = 100
export const WSMessageTypes = {
  RESULT: 'result',
  PROGRESS: 'progress',
  DONE: 'done',
  ERROR: 'error'
}
export const PROGRESS_COMPLETE_ANIMATION_DELAY = 300

export const FILTER_DROPDOWN_FIELDS = [
  { label: 'User ID', value: 'UserID' },
  { label: 'User ID at Tenant', value: 'UserIDAtTenant' },
  { label: 'Velocia ID at Tenant', value: 'VelociaIDAtTenant' },
  { label: 'Name', value: 'Name' },
  { label: 'Email', value: 'Email' }
]

export const FILTER_DROPDOWN_CONDITIONS = [
  { label: 'Contains', value: 'contains' },
  { label: 'Equals', value: 'equals' }
]

export const SELECT_INPUT_TYPES = {
  FIELD: 'field',
  CONDITION: 'condition'
}

export const SEARCH_FILTER_IDS = {
  FILTER_CARD: 'filter-card',
  SEARCH_VALUE: 'search-value',
  USER_ID: 'UserID',
  CONTAINS: 'contains',
  EQUALS: 'equals',
  NAME: 'Name'
}

export const SEARCH_FILTER_EMAIL_INFO =
  'Note: The email search will only work by entering the whole email information. A partial search for this field is not possible.'

export const DELETE_CONFIRM = 'deleteConfirm'
export const TESTER_CONFIRM = 'testerConfirm'

export const USER_ID_MAX_CHARACTERS = 8

export const SEARCH_FILTER_IGNORE_CLICK_SELECTOR = ['[data-headlessui-portal]']

export const FILTER_DROPDOWN_CONDITIONS_EMAIL_EXCLUDE = 'contains'
